import { isEmpty as _isEmpty, every as _every, some as _some } from 'lodash';

import { isEqualPipelineIntegrations } from '@ion/api';

import { DEPLOY_ACTIONS, DEPLOY_STATE, DEPLOY_STATE_TOOLTIP } from './DEPLOY_STATE';

export default function deployState({ assignedToCluster, deployedRevisions, pipelineIntegrations, loadingDiff }) {
  const stagedRevisions = pipelineIntegrations.map(pipelineIntegration => pipelineIntegration.stagedRevision);
  const deployedIonIntegrations = deployedRevisions.filter(integration => !integration.cliManaged);

  const enabled = {
    action: DEPLOY_ACTIONS.OPEN_PIPELINE_DIFF_MODAL,
    styleName: 'blueMed',
    buttonText: DEPLOY_STATE.DEPLOY,
    buttonTooltip: DEPLOY_STATE_TOOLTIP.DEPLOY,
  };
  if (loadingDiff) {
    return {
      buttonText: DEPLOY_STATE.LOADING,
      buttonTooltip: DEPLOY_STATE_TOOLTIP.LOADING,
    };
  }

  if (!assignedToCluster) {
    return {
      disabled: true,
      buttonText: DEPLOY_STATE.DEPLOY,
      buttonTooltip: DEPLOY_STATE_TOOLTIP.NOT_ASSIGNED_TO_CLUSTER,
    };
  }

  // set 'Delete' state if there are only deployed Ion integrations, no CLI-managed integrations,
  // and all stagedRevisions are staged for delete
  const hasDeployedIonIntegrations = !_isEmpty(deployedIonIntegrations);
  const hasCliManagedIntegrations = _some(deployedRevisions, ['cliManaged', true]);
  const allIonIntegrationsStagedForDelete = _every(stagedRevisions, ['stagedForDelete', true]);
  const allIntegrationsStagedForDelete =
    !hasCliManagedIntegrations && hasDeployedIonIntegrations && allIonIntegrationsStagedForDelete;
  if (allIntegrationsStagedForDelete) {
    return {
      styleName: 'blueMed',
      buttonText: DEPLOY_STATE.DEPLOY,
      action: DEPLOY_ACTIONS.OPEN_CONFIRM_DELETE_PIPELINE_DATA_MODAL,
      buttonTooltip: DEPLOY_STATE_TOOLTIP.STAGED_FOR_DELETE,
    };
  }

  // disable deployment if there are no staged changes
  const noStagedRevisions = _isEmpty(stagedRevisions);
  if (noStagedRevisions) {
    return { disabled: true, buttonText: DEPLOY_STATE.DEPLOY, buttonTooltip: DEPLOY_STATE_TOOLTIP.NO_STAGED_CHANGES };
  }

  // disable deployment if there are no differences from previous deployment
  const noPipelineIntegrationChanges = isEqualPipelineIntegrations({
    deployedRevisions: deployedIonIntegrations,
    pipelineIntegrations,
  });
  if (noPipelineIntegrationChanges) {
    return { disabled: true, buttonText: DEPLOY_STATE.DEPLOYED, buttonTooltip: DEPLOY_STATE_TOOLTIP.NO_CHANGES };
  }

  // disable deployment if there are staged integrations with missing pipeline vars
  const needStagedRevisions = _some(stagedRevisions, ['readyForDeploy', false]);
  if (needStagedRevisions) {
    return {
      styleName: 'orange',
      buttonText: DEPLOY_STATE.RESOLVE,
      buttonTooltip: DEPLOY_STATE_TOOLTIP.RESOLVE,
      action: DEPLOY_ACTIONS.OPEN_PIPELINE_VARIABLES_MODAL,
    };
  }

  return enabled;
}
